import styled, { css } from 'styled-components';
import { SideSheetClose, SideSheetHeader, Button, ButtonAppearance, Box } from '@bechtel/gds';

export const DrawerHeaderStyled = styled(SideSheetHeader)`
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white};
      color: ${theme.colors.grey[1000]};
    `}
`;

export const DrawerCloseStyled = styled(SideSheetClose).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) =>
    css`
      color: ${theme.colors.blue[800]};
      border: none;
    `}
`;

export const DrawerFooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding: ${theme.spacings[500]};
  `}
`;

export const ListSelectionStyled = styled(Box).attrs({ p: { sm: '500' }, alignItems: { sm: 'center' } })`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }
`;

export const SubListSelectionStyled = styled(ListSelectionStyled)`
  background-color: ${({ theme }) => theme.colors.grey[100]};
  justify-content: space-between;
`;

export const DrawerSubHeaderStyled = styled(Box).attrs({ pl: { sm: '500' }, pb: { sm: '500' }, pt: { sm: '600' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    font-size: ${theme.fontSizes[400]};
    font-weight: ${theme.fontWeights[600]};
    font-family: ${theme.fontFamilies.graphik};
  `}
`;
